import { Component } from '@angular/core';

@Component({
  selector: 'app-mini-loader', 
  templateUrl: './mini-loader.component.html',
  styleUrl: './mini-loader.component.scss'
})
export class MiniLoaderComponent {

}
